import { render, staticRenderFns } from "./Failed.vue?vue&type=template&id=61a69228&scoped=true"
import script from "./Failed.vue?vue&type=script&lang=js"
export * from "./Failed.vue?vue&type=script&lang=js"
import style0 from "./Failed.vue?vue&type=style&index=0&id=61a69228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a69228",
  null
  
)

export default component.exports